module.exports = __webpack_public_path__ + "media/images/panda-logo-925e219a1e5c6c5d72dc745910b8bd93.png";